export const routes = {
  app: `${process.env.NEXT_PUBLIC_ECHO_DOMAIN}`,
  login: '/login',
  invitation: '/invitation',
  termsAndConditions: `https://whalar.com/terms`,
  privacyPolicy: `https://whalar.com/privacy`,
  verifyEmail: '/verify-email',
  logout: '/logout',
  default: '/dashboard',
  brandSettings: '/brand-settings',
  influencersMessages: '/influencers/messages',
  influencersEditProfile: '/influencers/editprofile',
  ssoAppDomain: process.env.NEXT_PUBLIC_SSO_APP,
  ssoForgotPassword: `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/whalar/forgot-password`,
  ssoLogin: `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/whalar/login`,
  ssoLogout: `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/whalar/logout`,
} as const;
